// extracted by mini-css-extract-plugin
module.exports = {"learnMoreContainer":"styles_learnMoreContainer__1320t","content":"styles_content___zueE","title":"styles_title__2n4o5"};